document.addEventListener("DOMContentLoaded", function() {
    var input = document.getElementById('custombirthday');

     if (input) {  // Verifica se o elemento existe
            input.addEventListener('input', function() {
                var formattedValue = formatDateString(this.value);
                this.value = formattedValue;
                // validateDate(formattedValue);
                enforceMinLength(this);
                });
      }

    function formatDateString(value) {
        var formattedValue = value.replace(/\D/g, '').substr(0, 8);

        if (formattedValue.length > 2) {
            formattedValue = formattedValue.replace(/^(\d{2})(\d)/, '$1/$2');
        }
        if (formattedValue.length > 5) {
            formattedValue = formattedValue.replace(/^(\d{2})\/(\d{2})(\d)/, '$1/$2/$3');
        }

        return formattedValue;
    }

     /*function validateDate(dateString) {
        var parts = dateString.split("/");
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10) - 1; // Month is zero-based
        var year = parseInt(parts[2], 10);
        var inputDate = new Date(year, month, day);
        var today = new Date();
        
        console.log(inputDate);
        console.log(today);

        console.log(inputDate > today);

        if (inputDate > today) {
            input.setCustomValidity("A data não pode ser maior do que o dia de hoje.");
        } else {
            input.setCustomValidity("");
        }
    }*/

    function enforceMinLength(element) {
        if (element.value.length < 10) {
            element.setCustomValidity("Insira uma data completa (dd/mm/yyyy).");
        } else {
            element.setCustomValidity("");
        }
    }
});